import {enConfig} from './en';

export const arConfig = {
    ...enConfig.base,
    bismi:'بِسۡمِ ٱللهِ ٱلرَّحۡمَـٰنِ ٱلرَّحِيمِ',
    salaam:'ٱلسَّلَامُ عَلَيْكُمْ',
    header:{
        signup : 'التسجيل في أكثر صحة',

        signin : "الدخول",    
        signout : "خروج",
        close: "إغلاق",
        profile: "الملف الشخصي",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        about : "حول",
        article : "المقالات",
        contact : "تواصل",
        download: "تنزيل",
        joinus : "انضم إلينا",

    },
    
    home:{
        title : 'الرقمنة',
        article : 'المقالات',
        contact : 'تواصل',
        about: 'حول',
        connected: 'يجب أن تكون مسجلا',
    },

    blog: {
        ...enConfig.blog,
        title :'أكثر المقالات إثارة للاهتمام',
    },

    contact:{
        title:'تواصل معنا',
        message:'يرجى ملء النموذج أدناه لإرسال بريد إلكتروني إلينا',
        confirm:'تأكيد الاتصال',
        content:'يرجى ملء الرمز الذي أرسلناه إليك عبر البريد الإلكتروني لتأكيده',
        recipient:"يرجى تأكيد معلومات المستلم.",
        feedback : 'لقد تلقينا رسالتك، وسنعود إليك في أقرب وقت ممكن',
        warning : "يجب تأكيد بريدك الإلكتروني قبل المتابعة"
    },

    about:{
        title:'أكثر صحة',
        content:'استخدام التكنولوجيا والذكاء الاصطناعي لجعل الناس أكثر صحة',
    },

    getApp : {
        name : 'تنزيل تطبيق الخدمات',
        info : 'تنزيل تطبيق الخدمات',
        label : 'تنزيل تطبيق الخدمات'
    },

}
